(function(){
  const weeklyPath=/\/pages\/weekly\/?$/.test(window.location.pathname);
  if(!weeklyPath) return;

  const allowedDiets=['Keto','Low Carb','High Protein','Intermittent Fasting','OMAD','Whole-Food Focused'];

  try{
    const raw=localStorage.getItem('sk_dietary');
    if(raw){
      const parsed=JSON.parse(raw);
      if(Array.isArray(parsed)){
        const cleaned=[...new Set(parsed.filter((value)=>allowedDiets.includes(value)))];
        localStorage.setItem('sk_dietary',JSON.stringify(cleaned));
      }
    }
  }catch(e){}

  function normalizeTag(value){
    return String(value || '').toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ').trim();
  }

  function mealStatus(tags){
    const normalized=(Array.isArray(tags) ? tags : []).map(normalizeTag);
    if(normalized.includes('new this week')) return {label:'New This Week', cls:'sk-qa-status-new'};
    if(normalized.includes('fan favorite')) return {label:'Fan Favorite', cls:'sk-qa-status-fan'};
    if(normalized.includes('weekly staple')) return {label:'Weekly Staple', cls:'sk-qa-status-staple'};
    return null;
  }

  function applyMealStepRefinements(){
    const step=document.getElementById('sb-s3');
    if(!step) return;

    const totalNode=document.getElementById('cnt-total');
    const total=totalNode ? String(totalNode.textContent || '').trim() : '';
    const heading=document.getElementById('s3-heading');
    const sub=document.getElementById('s3-sub');
    if(heading){
      heading.innerHTML=total
        ? 'Choose your <em>'+total+' meals</em> for this week'
        : 'Choose your <em>meals</em> for this week';
    }
    if(sub){
      sub.textContent=total
        ? 'Build your weekly box by choosing '+total+' meals below. Choose any combination, including multiples of your favorites.'
        : 'Build your weekly box below. Choose any combination, including multiples of your favorites.';
    }

    step.querySelectorAll('.sb-macros').forEach(function(macros){
      const labels=macros.querySelectorAll('.sb-macro-l');
      if(labels.length) labels[labels.length-1].textContent='net carbs';
    });

    if(Array.isArray(window.SK_MEALS)){
      window.SK_MEALS.forEach(function(meal){
        const card=document.getElementById('mc-'+String(meal.id));
        if(!card) return;
        const bar=card.querySelector('.sb-meal-badge-bar');
        if(!bar) return;
        const status=mealStatus(meal.tags);
        if(!status){
          bar.innerHTML='';
          bar.style.display='none';
          return;
        }
        bar.style.display='';
        bar.innerHTML='<span class="sb-meal-tag '+status.cls+'">'+status.label+'</span>';
      });
    } else {
      step.querySelectorAll('.sb-meal-badge-bar').forEach(function(bar){
        bar.innerHTML='';
        bar.style.display='none';
      });
    }
  }

  function installMealRenderPatch(){
    if(typeof window.renderMeals !== 'function'){
      applyMealStepRefinements();
      return;
    }
    if(!window.renderMeals.__smoKetoQaStep3){
      const original=window.renderMeals;
      const wrapped=function(){
        const result=original.apply(this,arguments);
        applyMealStepRefinements();
        return result;
      };
      wrapped.__smoKetoQaStep3=true;
      window.renderMeals=wrapped;
    }
    applyMealStepRefinements();
  }

  function validatePreferenceGroups(){
    const step=document.getElementById('sb-s1');
    if(!step) return true;
    const groups=['goals','diets','allergens'];
    let firstMissing=null;
    groups.forEach(function(name){
      const grid=step.querySelector('[data-pref-group="'+name+'"]');
      const group=grid && grid.closest('.sb-pref-group');
      const valid=!!(grid && grid.querySelector('.sb-chip.sel'));
      if(group) group.classList.toggle('sk-qa-pref-group-error',!valid);
      if(!valid && !firstMissing) firstMissing=group || grid;
    });
    const error=document.getElementById('sk-qa-pref-error');
    if(error) error.style.display=firstMissing?'block':'none';
    if(firstMissing){
      firstMissing.scrollIntoView({behavior:'smooth',block:'center'});
      return false;
    }
    return true;
  }

  function installPreferenceGate(){
    if(typeof window.goStep!=='function' || window.goStep.__skQaPreferenceGate) return;
    const original=window.goStep;
    const wrapped=function(n){
      const next=parseInt(n,10);
      const step=document.getElementById('sb-s1');
      if(next===2 && step && step.classList.contains('active') && !validatePreferenceGroups()) return;
      return original.apply(this,arguments);
    };
    wrapped.__skQaPreferenceGate=true;
    window.goStep=wrapped;
  }

  function preparePreferenceValidation(step){
    if(!step) return;
    let error=document.getElementById('sk-qa-pref-error');
    if(!error){
      error=document.createElement('p');
      error.id='sk-qa-pref-error';
      error.className='sk-qa-pref-error';
      error.setAttribute('role','status');
      error.setAttribute('aria-live','polite');
      error.textContent='Please make at least one selection in each section before continuing.';
      const nav=step.querySelector('.sb-nav-row');
      if(nav) step.insertBefore(error,nav);
    }
    step.querySelectorAll('[data-pref-group] .sb-chip').forEach(function(button){
      button.addEventListener('click',function(){
        window.setTimeout(function(){
          const grid=button.closest('[data-pref-group]');
          const group=grid && grid.closest('.sb-pref-group');
          if(group && grid.querySelector('.sb-chip.sel')) group.classList.remove('sk-qa-pref-group-error');
          const anyMissing=['goals','diets','allergens'].some(function(name){
            const g=step.querySelector('[data-pref-group="'+name+'"]');
            return !(g && g.querySelector('.sb-chip.sel'));
          });
          if(!anyMissing && error) error.style.display='none';
        },0);
      });
    });
  }

  function stabilizeAddonSummary(){
    const list=document.getElementById('sb-upsell-list');
    const card=list && list.parentElement;
    const summary=document.getElementById('rv-addons-section');
    if(!card || !summary) return;
    summary.classList.add('sk-qa-selected-addons');
    const label=summary.querySelector('.sb-review-label');
    if(label) label.textContent='Selected Add-Ons';
    const deliveryMessage=card.querySelector('.sb-delivery-message');
    if(deliveryMessage && summary.nextElementSibling!==deliveryMessage) card.insertBefore(summary,deliveryMessage);
    else if(!deliveryMessage && summary.parentElement!==card) card.appendChild(summary);
  }

  document.addEventListener('DOMContentLoaded',function(){
    const style=document.createElement('style');
    style.textContent=[
      '.sk-qa-status-new{background:#b85c2a;color:#fff}',
      '.sk-qa-status-fan{background:#1c1c1c;color:#fff}',
      '.sk-qa-status-staple{background:#f3f0eb;color:#555;border:1px solid #ddd}',
      '.sk-qa-pref-group-error .sb-pref-heading{color:#a52a1a;border-left-color:#a52a1a}',
      '.sk-qa-pref-error{display:none;margin:10px 0 18px;padding:10px 13px;border-radius:10px;background:#fff6f3;color:#a52a1a;font-size:.76rem;font-weight:700}',
      '.sk-qa-selected-addons{margin-top:12px!important;padding:12px 0 0!important;border-top:1px solid #e8e2da!important;border-bottom:0!important}',
      '.sk-qa-selected-addons .sb-review-label{margin-bottom:6px!important}'
    ].join('');
    document.head.appendChild(style);

    const step=document.getElementById('sb-s1');
    const diets=step && step.querySelector('[data-pref-group="diets"]');
    if(step && diets){
      diets.innerHTML=allowedDiets.map(function(label){
        const safe=label.replace(/&/g,'&amp;').replace(/"/g,'&quot;');
        return '<button class="sb-chip" data-diet="'+safe+'" onclick="togChip(this)">'+safe+'</button>';
      }).join('');

      try{
        const saved=JSON.parse(localStorage.getItem('sk_dietary') || '[]');
        if(Array.isArray(saved)){
          diets.querySelectorAll('.sb-chip[data-diet]').forEach(function(button){
            if(saved.includes(button.dataset.diet)) button.classList.add('sel');
          });
        }
      }catch(e){}

      const note=step.querySelector('.sb-pref-note');
      if(note){
        note.textContent='These preferences help us personalize your SmoKeto experience. If you ever miss the weekly meal-selection cutoff, our kitchen team will use your responses and noted allergens to make the best available selections for your box.';
      }
      preparePreferenceValidation(step);
    }

    const planStep=document.getElementById('sb-s2');
    if(planStep){
      const heading=planStep.querySelector('.sb-step-heading');
      const sub=planStep.querySelector('.sb-step-sub');
      if(heading) heading.innerHTML='Choose Your <em>Weekly Plan</em>';
      if(sub) sub.textContent="Pick how many meals you'd like delivered each week.";
    }

    installMealRenderPatch();
    stabilizeAddonSummary();
    window.setTimeout(function(){
      installPreferenceGate();
      stabilizeAddonSummary();
    },0);
  });
})();
